import './Footer.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Icon from '@mdi/react';
import { mdiAccount, mdiCameraIris, mdiFacebook, mdiGithub, mdiInstagram, mdiLinkedin, mdiNoodles } from '@mdi/js';
import axios from "axios";
import React from 'react';


export default class Footer extends React.Component {
  state = {
    sections: [],
    socials: []
  }
  icons = {
    "mdiAccount":mdiAccount,
    "mdiCameraIris":mdiCameraIris,
    "mdiNoodles":mdiNoodles,
    "mdiFacebook":mdiFacebook,
    "mdiGithub":mdiGithub,
    "mdiInstagram":mdiInstagram,
    "mdiLinkedin":mdiLinkedin
  }
  

  componentDidMount() {
    const apiToken= process.env.REACT_APP_IARENAS_TOKEN;
    const getSectionsAPI='https://rg24xdvhj6.execute-api.us-east-1.amazonaws.com/default/iarenas-getSections'
    axios.post(
    getSectionsAPI,
    {'type':'section' },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiToken
      }
      }).then(res => {
        const sections = res.data;
        this.setState({ sections });
        
      })
      axios.post(
        getSectionsAPI,
        {'type':'social' },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiToken
          }
          }).then(res => {
            const socials = res.data;
            this.setState({ socials });
          })
  }


  render() {
    return (
      <Container fluid className="Footer d-block d-lg-none">
        <Row className='menuRow '>
        <Col md={2} /> 
          <Col md={8} className="" > 
            <Row>   
            <Col sm={12} lg={1} xxl={3}  className="mainLogo d-none d-lg-block" /> 
            {
            this.state.sections.map(section =>
                <Col key={section.section} className = "MenuColumn">
                  <a href={section.route} rel="noopener noreferrer"> 
                    <div  className='FooterNavi'> <Icon path={this.icons[section.mdiIcon]} className='icons'/><br/> {section.section.toUpperCase()}</div>
                  </a>
                </Col>
              
            )}
            <Col xxl={3} lg={1} className="d-none d-lg-block mainLogo"/> 
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
